import axios from 'axios'

export class IpService {
	private baseUrl = 'https://ipinfo.io/json'
	private cachedCountry: string | null = null
	private lastFetched: number | null = null
	private cacheTTL = 1000 * 60 * 60 * 2 // 2 hours in milliseconds

	public async getCountry(): Promise<string> {
		const now = Date.now()

		if (this.cachedCountry && this.lastFetched && now - this.lastFetched < this.cacheTTL) {
			return this.cachedCountry
		}

		try {
			const response = await axios.get(this.baseUrl, {
				headers: { Accept: 'application/json' }
			})

			this.cachedCountry = response.data.country
			this.lastFetched = now

			return this.cachedCountry
		} catch (error) {
			console.error('Failed to get country from IP:', error)
			throw error
		}
	}
}

export default new IpService()
